import { Location } from 'history';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthentication } from '~auth/useAuthentication';
import { useQueryParams } from '~utils/useQueryParams';
import { ForbiddenPage } from './403';

type LoginState = {
  from?: Location;
};

export function LoginPage() {
  const location = useLocation();
  const state = location.state as LoginState | undefined;
  const query = useQueryParams();

  const { loginWithRedirect, error } = useAuthentication();

  useEffect(() => {
    if (error) return;

    void loginWithRedirect({
      authorizationParams: {
        login_hint: query.get('email') ?? undefined,
      },
      appState: {
        returnTo: state?.from?.pathname,
      },
    });
  }, [loginWithRedirect, query, state, error]);

  return error ? <ForbiddenPage /> : null;
}
